"use strict";

var Logger = require("js-logger");

Logger.useDefaults({
	defaultLevel: Logger.ERROR
});

module.exports = {
	CartItemQuantity: require("./CartItemQuantity"),
	CartItemUseOnDay: require("./CartItemUseOnDay"),
	ChargeToday: require("./ChargeToday"),
	CheckoutActions: require("./CheckoutActions"),
	DonationAmount: require("./DonationAmount"),
	EventRegistrationHelper: require("../eventComponents/EventRegistrationHelper"), //Here because the EventsLayout.cshtml load it, checkoutComponents is used on less pages, but we really need to move everything to a single bundle.
	Frequency: require("./Frequency"),
	PaymentTypeSelector: require("./PaymentTypeSelector"),
	PayPalHelper: require("./PayPalHelper")
};



// WEBPACK FOOTER //
// ./Javascript/checkoutComponents/ExposedCheckoutComponents.jsx